Wee.fn.make('header', {
	init: function() {
		var priv = this.$private;

		Wee.commerce.initMiniCart({
			model: $.get('cart')
		});

		$.screen.map([
			{
				max: 3,
				init: false,
				callback: function() {
					priv.destroyMiniCartEvents();
					Wee.sticky.destroy();
				}
			},
			{
				min: 4,
				callback: function() {
					priv.initMiniCartEvents();
					priv.initSticky();
				}
			}
		]);
	}
}, {
	/**
	 * Init mini cart
	 *
	 * @private
	 */
	initMiniCartEvents: function() {
		var scope = this,
			$miniCart = $('ref:miniCart');

		$.events.on({
			'ref:miniCart': {
				'mouseenter': function() {
					if (! scope.$get('sticky')) {
						$miniCart.activate();
					}
				},
				'mouseleave': function() {
					$miniCart.deactivate();
				},
				'click': function() {
					$miniCart.deactivate();
				}
			}
		}, {
			delegate: 'ref:miniCart'
		});

		$.history.bind({
			click: 'ref:miniCartCheckout'
		});
	},

	/**
	 * Destroy mini cart
	 *
	 * @private
	 */
	destroyMiniCartEvents: function() {
		$.events.off(false, '.miniCart');
	},

	/**
	 * Init sticky header
	 *
	 * @private
	 */
	initSticky: function() {
		var $header = $('ref:header');

		Wee.sticky.init('ref:header', {
			start: 300,
			stuck: function() {
				$header.wrap('<div class="header-wrapper" data-ref="headerWrapper"></div>');
			},
			unstuck: function() {
				var $wrapper = $('ref:headerWrapper');

				$header.insertAfter($wrapper);

				$wrapper.remove();
			}
		});
	}
});